import ChevronLeft from '@mdi/svg/svg/chevron-left.svg?react';
import ChevronRight from '@mdi/svg/svg/chevron-right.svg?react';
import PageFirst from '@mdi/svg/svg/page-first.svg?react';
import PageLast from '@mdi/svg/svg/page-last.svg?react';
import React from 'react';
import styled from 'styled-components';
import { COLOR, FONT_SIZE } from '../../styles';
import { Button } from '../Button';
import { Flex } from '../Flex';
import { MDIIcon } from '../MDIIcon';
import { type TablePaginationProps } from './types';

const TablePagination: React.FC<TablePaginationProps> = (props) => {
  const {
    handleNextPage,
    handlePreviousPage,
    handleFirstPage,
    handleLastPage,
    canGoToPreviousPage,
    canGoToNextPage,
    paginationText,
  } = props;
  return (
    <PaginationWrapper alignItems="center" justifyContent="flex-end">
      <Button
        icon={<MDIIcon icon={PageFirst} />}
        iconOnly={true}
        onClick={handleFirstPage}
        disabled={!canGoToPreviousPage}
        type="clear"
      />
      <Button
        icon={<MDIIcon icon={ChevronLeft} />}
        iconOnly={true}
        onClick={handlePreviousPage}
        disabled={!canGoToPreviousPage}
        type="clear"
      />
      <PageCount>{paginationText}</PageCount>
      <Button
        icon={<MDIIcon icon={ChevronRight} />}
        iconOnly={true}
        onClick={handleNextPage}
        disabled={!canGoToNextPage}
        type="clear"
      />
      <Button
        icon={<MDIIcon icon={PageLast} />}
        iconOnly={true}
        onClick={handleLastPage}
        disabled={!canGoToNextPage}
        type="clear"
      />
    </PaginationWrapper>
  );
};

const PageCount = styled.span``;

const PaginationWrapper = styled(Flex)`
  padding: 1rem 0;
  color: ${COLOR['dark-gray-lightest']};
  font-weight: 400;
  font-size: ${FONT_SIZE['14']};
`;

export default TablePagination;
